import { render } from "./SearchAdmin.vue?vue&type=template&id=6f5c07cd&scoped=true"
import script from "./SearchAdmin.vue?vue&type=script&lang=js"
export * from "./SearchAdmin.vue?vue&type=script&lang=js"

import "./SearchAdmin.vue?vue&type=style&index=0&id=6f5c07cd&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5c07cd"]])

export default __exports__